<template>
  <div class="my-account-page">
    <div class="my-account" v-loading="loading">
      <div class="title">我的账户</div>
      <div class="money">
        <div class="money-line">
          <div v-if="formData.paymentMode === 'PAYMENT'" class="money-line-limit">
            {{ formData.accountBalance ? formData.accountBalance : '0.00' }}
          </div>
          <div v-if="formData.paymentMode === 'CREDIT'" class="money-line-limit">
            {{ formData.creditBalance ? formData.creditBalance : '0.00' }}
          </div>
          <div>{{ formData.paymentMode === 'CREDIT' ? '授信额度(元)' : '账户余额(元)' }}</div>
        </div>
      </div>
    </div>

    <!--    <div class="order-title">订单记录</div>-->
    <div v-if="formData.paymentMode === 'PAYMENT'" v-loading="orderLoading">
      <div class="order-bg" v-if="orderList.records && orderList.records.length > 0">
        <div class="order-bg-subtitle">
          <div>时间</div>
          <div>类型</div>
          <div>金额</div>
        </div>
        <div class="line"></div>
        <div v-for="(item,index) in orderList.records" :key="index">
          <div class="order-bg-content">
            <div>{{ item.createTime }}</div>
            <div v-if="item.serviceType === '0'">充值</div>
            <div v-if="item.serviceType === '1'">消费</div>
            <div v-if="item.serviceType === '2'">退款</div>
            <div>{{ item.serviceType === '1' ? '-' : '+' }}{{ item.changeAmount }}</div>
          </div>
          <div class="dashed"></div>
        </div>
      </div>
      <el-empty v-else description="暂无账户明细"></el-empty>
      <div class="paging" v-if="orderList.records && orderList.records.length > 0">
        <el-pagination
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="orderList.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getEnterprisesInfo} from "@/api/mycenter";
import {getAccountBill} from "@/api/order"

export default {
  name: "myAccount",
  beforeMount() {
    this.getEnterprisesInfo();
  },
  data() {
    return {
      loading: false,
      orderLoading: false,
      formData: {
        paymentMode: 'PAYMENT'
      },
      orderList: {},
      current: 1
    }
  },
  methods: {
    getEnterprisesInfo() {
      this.loading = true;
      getEnterprisesInfo().then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.formData = result.data;
          if(result.data.paymentMode === 'PAYMENT'){
            this.getAccountBill();
          }
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    getAccountBill() {
      let params = {
        current: this.current,
        size: 10
      }
      this.orderLoading = true;
      getAccountBill(params).then(result => {
        this.orderLoading = false;
        if (result && result.code === "0") {
          this.orderList = result.data;
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }

      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    currentChange(current) {
      this.current = current;
      this.getAccountBill()
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.my-account-page {
  .my-account {
    padding: 30px 24px 30px;
    background: #FFFFFF;
    border-radius: 8px;

    .title {
      line-height: 1;
      font-size: 16px;
      font-weight: bold;
      color: #262728;
    }

    .money {
      display: flex;
      align-items: center;

      .money-line {
        margin-right: 123px;
        font-size: 14px;
        font-weight: 400;
        color: #606366;
        line-height: 1;

        .money-line-limit {
          font-size: 28px;
          font-weight: bold;
          color: #262728;
          margin: 30px 0 12px;
        }
      }
    }
  }

  .order-title {
    font-size: 24px;
    font-weight: 400;
    color: #262728;
    line-height: 1;
    margin-top: 30px;
  }

  .order-bg {
    background-color: #FFFFFF;
    border-radius: 8px;
    margin-top: 20px;
    text-align: left;

    .order-bg-subtitle {
      height: 44px;
      line-height: 44px;
      display: grid;
      grid-template-columns: repeat(3, 33%);
      margin-left: 60px;
    }

    .line {
      border-bottom: 10px solid #f4f4f4;
    }

    .order-bg-content {
      display: grid;
      grid-template-columns: repeat(3, 33%);
      margin-left: 60px;
      padding: 20px 0 20px;
      line-height: 1;
      font-size: 14px;
    }

    .dashed {
      border-bottom: 1px dashed #EDEFF2;
    }
  }

  .paging {
    text-align: center;
    margin-top: 34px;


    .el-pagination {
      .btn-prev {
        background-color: #f8f8f8;
      }

      .el-pager li {
        min-width: 28px;
        background-color: #f8f8f8;
      }

      .el-pager {
        .active {
          color: #000;
          box-sizing: border-box;
          border-radius: 8px;
          background-color: $main;
        }
      }

      .btn-next {
        background-color: #f8f8f8;
      }
    }
  }
}
</style>